// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"trailmap_wrapper__u_IB1"};